import {ENDPOINTS_EMPLOYEE} from 'common/endpoints/vacations-absences.endpoints';
import {ENDPOINTS_MANAGER} from 'common/endpoints/vacations-absences.endpoints';

class modalCalendarGridService {

  constructor($http) {
    'ngInject';
    this.http = $http;
  }

  getRequestModalPeriods(employeeId, isInception, managerId) {
    if (isInception) {
      return this.http.get(ENDPOINTS_MANAGER.get.schedule(employeeId, managerId));
    }
    return this.http.get(ENDPOINTS_EMPLOYEE.get.schedule(employeeId));
  }

}

export default modalCalendarGridService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalCalendarGrid/modalCalendarGrid.Service.js